<template>
  <v-container fluid>
    <v-row v-if="value.title || value.paragraph" dense justify="center">
      <v-col class="text-center" cols="12" md="8">
        <h2 v-if="value.title" class="text-h4 text-sm-h3 font-weight-bold">
          {{ value.title }}
        </h2>

        <p
          v-if="value.paragraph"
          class="text-body-1 text-blue-darken-4 text-uppercase font-weight-bold mb-2"
        >
          {{ value.paragraph }}
        </p>
      </v-col>
    </v-row>

    <v-row v-if="imageItems && imageItems.length" justify="center">
      <v-col
        v-for="item in imageItems"
        :key="item.id"
        class="text-center"
        cols=""
      >
        <v-avatar rounded="0" size="120">
          <v-img
            :src="imgSrc(item.image)"
            alt="Photo for the service category"
          />
        </v-avatar>

        <h6
          :value="item.title"
          class="text-body-1 text-blue-darken-4 font-weight-black mt-3"
        >
          {{ item.title }}
        </h6>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed } from 'vue'
import { createImgSrc } from '#root/lib/img'

const props = defineProps({
  value: {
    required: true,
    type: Object
  }
})

const imgSrc = createImgSrc()
const imageItems = computed(() => {
  return props.value.items && props.value.items.filter(item => item.image)
})
</script>
